/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { HTMLAttributes } from 'react';
import cx from 'classnames';
import { Icon } from 'sarsaparilla';

import styles from './IconBadge.module.scss';

export type IconBadgeSize = 'md' | 'sm';

export type IconBadgeName =
    | 'tent'
    | 'ticket'
    | 'card'
    | 'permit'
    | 'picnic-table'
    | 'tree'
    | 'pin'
    | 'celebration'
    | 'help-outline'
    | 'description'
    | 'add-circle-outline'
    | 'compass'
    | 'map'
    | 'quote'
    | 'history';

export interface IconBadgeProps extends HTMLAttributes<HTMLDivElement> {
    iconName: IconBadgeName;
    size?: IconBadgeSize;
    isHistory?: boolean;
    isNearMe?: boolean;
}

export function IconBadge({
    iconName,
    size = 'md',
    className,
    isHistory = false,
    isNearMe = false,
    ...rest
}: IconBadgeProps) {
    return (
        <div
            data-component="IconBadge"
            className={cx(styles.badge, styles[size], styles[iconName], className, {
                [styles.history]: isHistory,
                [styles.nearMe]: isNearMe,
            })}
            {...rest}
        >
            <Icon iconName={iconName} />
        </div>
    );
}
